/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Szoa304aRequestCtrTanka { 
    /**
     * 商品コード：英数字
     */
    goodsCode: string;
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode: string;
    /**
     * 単価指定区分１：数字
     */
    tankaSiteiDiv1: string;
    /**
     * 単価指定区分２：数字
     */
    tankaSiteiDiv2: string;
    /**
     * 単価指定区分３：数字
     */
    tankaSiteiDiv3: string;
    /**
     * 単価指定区分４：数字
     */
    tankaSiteiDiv4: string;
    /**
     * 単価指定区分５：数字
     */
    tankaSiteiDiv5: string;
    /**
     * 契約単価正式名称：全角
     */
    ctrtnkAname?: string;
    /**
     * 契約単価略称名称：全角
     */
    ctrtnkRyaku?: string;
    /**
     * 単価範囲開始値
     */
    tankaRangeStart: number;
    /**
     * 単価範囲終了値
     */
    tankaRangeEnd: number;
    /**
     * 契約単価
     */
    tanka: number;
    /**
     * 調整単価コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C001300」のユーザコードを設定
     */
    choseiTankaCode?: string;
}

